<template>
  <div :class="container_class">
    <div :class="mobile_webgl_class">
      <MobileContainer ref="mobileContainer"></MobileContainer>
    </div>
    <!--    <AudioManager ref="audio_manager" />-->
  </div>
</template>

<script>
import { mapState } from "vuex";
import MobileContainer from "../components/IframeContainer";
import AudioManager from "../components/AudioManager";

export default {
  name: "ContentContainer",
  components: {
    MobileContainer,
    AudioManager
  },
  data() {
    return {
      initialized: false,
      extra_webgl_class: ""
    };
  },
  computed: {
    ...mapState([
      "app_type",
      "app_state",
      "page_state",
      "sections",
      "sections_content",
      "parentRatio"
    ]),
    mobile_webgl_class() {
      var class_str = "hidden-container  mx-auto";

      if (this.parentRatio < 9 / 16) {
        class_str += " extra-landscape";
      }

      return class_str + this.extra_webgl_class;
    },
    container_class() {
      let str = "unity-content-container ";

      if (this.app_state >= 2) {
        str += "ready";
      }
      return str;
    }
  },
  methods: {
    //this is the logic for the guided tour
    check_transition_status() {},

    on_section_anim_ended(transition_id) {
      console.log("anim section ended", transition_id);

      this.on_area_btn_click(transition_id);
    },
    on_area_btn_click(area) {
      console.log(area, "area clicked", area == "3");

      this.call_section_content(area.id, area.subid);
    },

    call_section_content(section_id, section_subid) {
      console.log(section_id, section_subid);

      let section_exists = false;
      this.sections.forEach((item) => {
        if (section_id + "" == item.id) {
          section_exists = true;
        }
      });
      if (section_exists) {
        this.$store.dispatch("set_current_section", section_id + "");
        this.$store.dispatch("set_current_subsection", section_subid);
      } else {
        this.$store.dispatch("set_secondary_section", {
          section: section_id,
          sub_section: section_subid
        });
      }

      this.$store.dispatch(
        "set_popup_state",
        this.sections_content[section_id].subids[section_subid].type
      );
    }
  },
  mounted() {
    this.$bus.$on("on-section-anim-ended", this.on_section_anim_ended);
    this.$bus.$on("on-area-btn-click", this.on_area_btn_click);

    //todo:find a way to check if browser is safari, this was done via unity
    //this.$bus.$emit("is-safari", true);
  },
  watch: {
    app_state(val) {
      //this happens when the intro stuff (form and intro video)
      //are done. we delay full initialization a bit so we give the intro time to fade out
      if (val == 0) {
        setTimeout(
          (() => {
            this.extra_webgl_class += " active";
            if (!this.initialized) {
              this.$store.dispatch("set_app_state", 2);
              this.initialized = true;

              this.$bus.$emit("on-activating-content", true);
              this.$bus.$emit("on-request-audio", "ambience");
              this.$bus.$emit(
                "on-request-ambience-fade",
                this.$store.state.ambience_volume
              );

              // setTimeout(
              //   function () {
              //     this.$store.dispatch("set_popup_state", "instructions");
              //   }.bind(this),
              //   900
              // );
            }
          }).bind(this),
          800
        );
      }
    }
  }
};
</script>
<style>
.unity-content-container {
  display: flex;
  align-items: stretch;
}
.unity-content-container .hidden-container {
}
.unity-content-container.ready {
  height: auto;
  overflow: visible;
}
.unity-content-container {
  height: 0;
  overflow: hidden;
}
.webgl-content * {
  border: 0;
  margin: 0;
  padding: 0;
}
.webgl-content {
  width: 100%;
  flex: 1;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: stretch;
}

.webgl-content .logo,
.progress {
  position: absolute;
  left: 50%;
  bottom: 30px;
  -webkit-transform: translate(-50%, 0);
  transform: translate(-50%, 0);
}
.webgl-content .logo {
  width: 154px;
  height: 130px;
}
.webgl-content .progress {
  height: 18px;
  width: 50%;
  margin-top: 0;
}
.webgl-content .progress .empty {
  float: right;
  width: 100%;
  height: 100%;
  display: inline-block;
}
.webgl-content .progress .full {
  float: left;
  width: 0%;
  height: 100%;
  display: inline-block;
}

.webgl-content .logo.Dark {
  background-image: none;
}
.webgl-content .progress.Dark .empty {
  background: #101010;
}
.webgl-content .progress.Dark .full {
  background: green;
}

.webgl-content .footer {
  margin-top: 5px;
  height: 38px;
  line-height: 38px;
  font-family: Helvetica, Verdana, Arial, sans-serif;
  font-size: 18px;
}
.webgl-content .footer .webgl-logo,
.title,
.fullscreen {
  height: 100%;
  display: inline-block;
  background: transparent center no-repeat;
}
.webgl-content .footer .webgl-logo {
  width: 204px;
  float: left;
}
.webgl-content .footer .title {
  margin-right: 10px;
  float: right;
}
.webgl-content .footer .fullscreen {
  width: 38px;
  float: right;
}
.unityContainer {
  width: 100%;
  xmax-height: 60vh;
}
.active .unityContainer {
  height: 50vh;
  overflow: hidden;
}
.webgl-content canvas {
  height: 100% !important;
}

.is-safari .webgl-content {
}
.is-safari.active .unityContainer {
  display: block;
}

.hidden-container {
  height: 6px;
  overflow: hidden;
  opacity: 0;
  transition: opacity 0.5s;
  transition-delay: 0.7s;
  width: 100%;
  flex-flow: column;
  position: relative;

  justify-content: flex-end;
  align-items: stretch;
}
.hidden-container.active {
  flex: 1;
  opacity: 1 !important;
  display: flex;
  height: auto;
}

.app_sidebar {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 90vw;
  margin: 15px auto;
  border-radius: 10px;
}
.webgl-container {
  flex: 1;
}

.extra-landscape {
  background: #2c5792;
}
@media screen and (min-width: 1100px) and (-webkit-min-device-pixel-ratio: 1.5),
  screen and (min-width: 1100px) and (min-resolution: 192dpi) {
  .hidden-container.active {
    justify-content: center;
  }
  .webgl-content {
    flex: 0;
    min-height: 550px;
    height: 60vh;
    max-width: 1100px !important;
    margin-left: auto;
    margin-right: auto;
  }
  .is-safari .webgl-content canvas {
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ContentContainer.vue